exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list[data-v-5b86814e] {\n  /*padding:20px 0;*/\n}\n.more[data-v-5b86814e],\n.no-more[data-v-5b86814e],\n.loading[data-v-5b86814e] {\n  text-align: center;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5b86814e&scoped=true!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/article-list.vue
// module id = 234
// module chunks = 1